<template>
  <v-card
    width="260px"
    :color="isActive ? primaryColor : ''"
    :dark="isActive"
    outlined
    ripple
    hover
    class="rentpress-shortcode-unit-card pa-2"
    :class="
      isActive
        ? 'rentpress-unit-selected rentpress-unit-' + unit.unit_name
        : 'rentpress-unit-' + unit.unit_name
    "
  >
    <v-card-text
      :style="isActive ? { color: getContrastingTextColor(primaryColor) } : {}"
      class="rentpress-inherited-font-family pa-0 ma-0 text-h6 rentpress-unit-text"
      align="left"
    >
      <span
        :class="
          isActive
            ? 'font-weight-bold rentpress-no-wrap-text'
            : 'font-weight-bold secondary--text rentpress-no-wrap-text rentpress-unit-name'
        "
      >
        {{ unit.unit_name }}
      </span>
      <div>
        <span v-if="unit.unit_specials_message">
          <v-tooltip bottom open-delay="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                :ripple="false"
                class="rentpress-unit-icon-special"
                :style="
                  isActive
                    ? { color: getContrastingTextColor(primaryColor) }
                    : { color: primaryColor }
                "
              >
                <v-icon>{{ $vuetify.icons.values.starCircleOutline }}</v-icon>
              </v-btn>
            </template>
            View Specials
          </v-tooltip>
        </span>
        <span
          v-if="
            unit.unit_rent_type_selection_cost &&
              unit.unit_rent_type_selection_cost > 100 &&
              !disablePrice &&
              !disabledPrice
          "
          class="rentpress-inherited-font-family text-subtitle-1 rentpress-unit-price"
        >
          {{ this.formatter.format(unit.unit_rent_type_selection_cost) }}/mo
        </span>
        <span
          v-if="
            unit.unit_rent_type_selection_cost &&
              unit.unit_rent_type_selection_cost > 100 &&
              !disablePrice &&
              !disabledPrice &&
              unit.unit_sqft
          "
          class="rentpress-inherited-font-family text-subtitle-1 rentpress-unit-text-separator"
        >
          •
        </span>
        <span v-else>
          {{
            options.rentpress_disable_pricing_section_disable_pricing_message
          }}
        </span>
        <span
          v-if="unit.unit_sqft && unit.unit_sqft > 100"
          class="rentpress-inherited-font-family text-subtitle-1 rentpress-unit-size"
        >
          {{ unit.unit_sqft }} sq. ft.
        </span>
      </div>
      <div>
        <span
          v-if="unitAvailable"
          class="rentpress-inherited-font-family text-subtitle-1 rentpress-unit-available-date"
        >
          Available Now
        </span>
        <span
          v-else
          class="rentpress-inherited-font-family text-subtitle-1 rentpress-unit-available-date"
        >
          Available On {{ unit.unit_ready_date }}
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "unit-card",
  data: function() {
    return {
      unitAvailable: false,
      disablePrice: this.options
        .rentpress_disable_pricing_section_disable_pricing
    };
  },
  props: {
    unit: Object,
    options: Object,
    isActive: Boolean,
    formatter: Intl.NumberFormat,
    primaryColor: String,
    disabledPrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    getContrastingTextColor(color) {
      if (!color) return "#202124";
      const c = color.replace("#", "");
      const rgb = parseInt(c, 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? "#202124" : "#FDFDFD";
    }
  },
  mounted: function() {
    var today = new Date();
    this.unitAvailable = Date.parse(this.unit.unit_ready_date) < today;
  }
};
</script>
<style>
.v-application .rentpress-shortcode-unit-card {
  background-color: transparent;
  border-width: medium !important;
}

/* Icon button styling */
.rentpress-unit-icon-special {
  width: 5px !important;
  height: 5px !important;
  margin: 0 10px 0 5px !important;
  background: transparent !important;
  position: relative;
  pointer-events: auto;
}

/* Icon button internal Vuetify overlay */
.rentpress-unit-icon-special .v-btn__overlay {
  background-color: transparent !important;
  opacity: 0 !important;
}

/* Hover effects */
.rentpress-shortcode-unit-card:hover .rentpress-unit-icon-special,
.rentpress-unit-icon-special:hover {
  background: transparent !important;
}
</style>
